module.exports = __webpack_public_path__ + "static/media/NickKraly_2018_CV.6283f5eb.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/images/NickKraly_2018_CV.pdf
// module id = 150
// module chunks = 0